import jquery from "jquery";

window.jQuery = jquery
window.$ = jquery

$.copyText = function (str) {
  if (typeof str != 'string') {
    str = $(str)[0].innerText.trim()
  }

  let el = document.createElement('textarea')
  el.value = str
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

$.debounce = function(func, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

// reload div by ID, similar to turbo-frame, but works anywhere
$.fn.reload = function(path) {
  path ||= this.attr('src') || this.attr('path') || this.attr('data-src') || location.pathname + location.search

  let selector = this.attr('id') ? `#${this.attr('id')}` : null
  selector ||= this && this[0] && this[0].nodeName == 'BODY' ? 'BODY' : null
  selector || alert('no ID for reload()')

  const oldNode = this
  $.get(path, (r) => {
    const newNode = $(`<div>${r}</div>`).find(selector)
    if (newNode[0]) {
      oldNode.html( newNode.html() )
    } else {
      oldNode.html( r )
    }
  })
}

// drag and pan horizontally scrollable block
$.fn.pannableBlock = function () {
  return this.each(function () {
    const el = $(this);
    let isDown = false;
    let startX;
    let scrollLeft;

    el.on('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - el.offset().left;
      scrollLeft = el.scrollLeft();
      el.css('cursor', 'move');
    });

    el.on('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offset().left;
      const walk = (x - startX) * 2;
      el.scrollLeft(scrollLeft - walk);
      document.body.classList.add('no-select');
    });

    $(document).on('mouseup', function () {
      isDown = false;
      el.css('cursor', 'default');
      document.body.classList.remove('no-select');
    });
  });
};
